import { render } from "./UpdateJobModal.vue?vue&type=template&id=53544dd0"
import script from "./UpdateJobModal.vue?vue&type=script&lang=js"
export * from "./UpdateJobModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__